var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-countdown-wrapper"},[_vm._t("countdown-container",function(){return [_c('div',[_vm._v(_vm._s(_vm.days)+":"+_vm._s(_vm.hours)+":"+_vm._s(_vm.mins)+":"+_vm._s(_vm.secs))])]},{"days":_vm.days,"hours":_vm.hours,"mins":_vm.mins,"secs":_vm.secs})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }